// src/utils/layoutUtils.js
export const getDefaultSettings = (category, layout) => {
  const defaultSettings = {
    grid: {
      masonry: {
        columnsBreakpoints: { mobile: 1, tablet: 2, desktop: 3, wide: 4 },
        gutter: 16,
        adaptiveHeight: true,
        fillOrder: 'optimized'
      },
      uniformGrid: {
        columnsBreakpoints: { mobile: 1, tablet: 2, desktop: 3, wide: 4 },
        gutter: 16,
        aspectRatio: '1:1',
        cropToFit: true
      },
      bento: {
        columnsBreakpoints: { mobile: 1, tablet: 2, desktop: 4, wide: 6 },
        gutter: 12,
        patternType: 'dynamic',
        featuredRatio: 0.3,
        minCellSpan: 1,
        maxCellSpan: 3
      }
    },
    narrative: {
      heroFlow: {
        heroRatio: 0.4,
        flowDirection: 'vertical',
        heroPosition: 'top',
        supportingLayout: 'masonry'
      },
      magazineSpread: {
        spreadType: 'featured',
        textOverlay: true,
        captionStyle: 'overlay',
        readingFlow: 'z-pattern'
      },
      timelineFlow: {
        orientation: 'vertical',
        markerStyle: 'dots',
        branchingEnabled: false,
        timelineWidth: 'full'
      }
    },
    artistic: {
      constellation: {
        clusterCount: 3,
        connectionLines: true,
        animatedEntry: true,
        gravityCenters: ['color', 'date']
      },
      riverFlow: {
        flowDirection: 'serpentine',
        curvatureStrength: 'medium',
        branchingPoints: 2,
        flowSpeed: 'medium'
      },
      floatingIslands: {
        islandCount: 'auto',
        connectionStyle: 'bridges',
        islandShape: 'organic',
        whitespaceRatio: 0.3
      }
    },
    interactive: {
      revealOnScroll: {
        revealPattern: 'cascade',
        scrollTrigger: 0.7,
        revealDirection: 'bottom',
        groupReveal: false
      },
      parallaxLayers: {
        layerCount: 3,
        depthMultiplier: 0.5,
        backgroundLayer: true,
        foregroundAccents: true
      },
      morphingGrid: {
        morphTrigger: 'hover',
        morphStyle: 'expand',
        adaptToContent: true,
        transitionDuration: '0.3s'
      }
    },
    minimal: {
      centerStage: {
        focusRatio: 0.6,
        supportingStyle: 'thumbnails',
        transitionType: 'slide',
        autoAdvance: false
      },
      breathingRoom: {
        contentDensity: 'sparse',
        whitespaceRatio: 0.5,
        alignmentPattern: 'asymmetric',
        rhythmPattern: 'fibonacci'
      }
    }
  };

  return defaultSettings[category]?.[layout] || {};
};

export const generateSampleItems = (count = 8) => {
  return Array.from({ length: count }, (_, index) => ({
    id: `sample-${index}`,
    type: 'image',
    url: `https://picsum.photos/400/600?random=${index}`,
    title: `Sample Image ${index + 1}`,
    description: `Sample description for image ${index + 1}`,
    order: index
  }));
};